import { createStyles }     from "@mantine/core";
import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => ( {
	root: {
		backgroundColor: theme.other.darkMode ?
			theme.other.paletteNew.darkModeDarkGrey :
			theme.other.paletteNew.secondaryBackgroundGrey,
		width        : "100%",
		borderRadius : "10px",
		padding      : "1.8rem",
		paddingRight : "4rem",
		borderWidth  : "0",
		height       : "4rem",
		fontSize     : "1.4rem",
		justifySelf  : "center",

		[rooterMediaQuery.mobileAndTablet]: {
			width: "100%"
		}

	},
	searchBarContainer: {
		flex         : "1",
		color        : theme.other.colors.text.primary,
		// backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeDarkGrey : theme.other.paletteNew.secondaryBackgroundGrey,
		borderRadius : "10px",

		"& .MuiTypography-body1": {
			color: theme.other.darkMode ? theme.other.paletteNew.secondaryDarkGrey : "#00000080"
		}
	},
	input: {
	},
	cssFocused: {
		borderColor: "#126bd5 !important"
	},
	crossIcon: {
		height : "2.6rem",
		width  : "2.6rem"
	}
} ) );
